"use client";

import { useEffect, useRef, type RefObject } from "react";

import { registerBackCloser } from "./back-closes";

/**
 * O voltar do Android na camada que tem fechar PRÓPRIO (ver
 * `lib/ui/back-closes`): enquanto `active`, o elemento do `ref` fica
 * registrado com `onBack`. Quando ele é a camada de cima, o voltar chama
 * `onBack` em vez de mandar um Esc.
 *
 * Usos: o visualizador de fotos (não é do Radix) e a folha de baixo no 2º
 * passo, onde o voltar volta ao passo anterior, como o "‹" dela.
 */
export function useBackClose(
  ref: RefObject<Element | null>,
  onBack: () => void,
  active = true,
) {
  const onBackRef = useRef(onBack);
  useEffect(() => {
    onBackRef.current = onBack;
  });
  useEffect(() => {
    const el = ref.current;
    if (!active || !el) return;
    return registerBackCloser(el, () => onBackRef.current());
  }, [ref, active]);
}
